import { useClerk } from "@clerk/react";
import type { AdminMe } from "@luckymenu/core";
import { useTranslation } from "@luckymenu/i18n/react";
import {
	Avatar,
	AvatarFallback,
	AvatarImage,
	Button,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@luckymenu/ui-web";
import { LogOut } from "lucide-react";

export function initials(name: string | null, email: string | null): string {
	const source = name?.trim() || email?.trim() || "?";
	const parts = source.split(/\s+/).filter(Boolean);
	const letters = parts.length > 1 ? `${parts[0]?.[0]}${parts[1]?.[0]}` : source.slice(0, 2);
	return letters.toUpperCase();
}

export function AccountMenu({ me }: { me: AdminMe }) {
	const { t } = useTranslation(["admin", "auth"]);
	const { signOut } = useClerk();
	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				render={<Button variant="ghost" size="icon" aria-label={t("account")} />}
			>
				<Avatar>
					{me.avatarUrl ? <AvatarImage src={me.avatarUrl} alt="" /> : null}
					<AvatarFallback>{initials(me.name, me.email)}</AvatarFallback>
				</Avatar>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="min-w-56">
				<DropdownMenuGroup>
					<DropdownMenuLabel>
						<div className="font-medium text-foreground">{me.name ?? me.email}</div>
						{me.name && me.email ? <div className="text-muted-foreground">{me.email}</div> : null}
					</DropdownMenuLabel>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={() => void signOut()}>
					<LogOut />
					{t("auth:signOut")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
